import { cn } from '@/utils/tailwind.util';
import type { FolderColor } from '../types/folder.types';
import { folderColorHex } from '../utils/folderColor';
import { FOLDER_BOX, FOLDER_BOX_HERO, FOLDER_BOX_HERO_MOBILE, FOLDER_BOX_ROW, FolderShape, type FolderShapeSize } from './FolderShape';
const THUMBNAIL_SLOT_COUNT = 4;
const EMPTY_IMAGE_URLS: string[] = [];

/** 썸네일 크기는 폴더 윤곽(`FolderShape`)의 크기와 1:1 이다. */
export type FolderThumbnailSize = FolderShapeSize;
const SIZE_STYLE: Record<FolderThumbnailSize, {
  box: string;
  offset: string;
  grid: string;
  slot: string;
}> = {
  card: {
    box: FOLDER_BOX,
    offset: 'pt-[8px] max-tablet-lg:pt-[6px]',
    grid: 'h-[90px] gap-[6px] rounded-md p-xs max-tablet-lg:h-[53px] max-tablet-lg:gap-[2px] max-tablet-lg:p-3xs',
    slot: 'rounded-sm max-tablet-lg:rounded-2xs'
  },
  hero: {
    box: FOLDER_BOX_HERO,
    offset: 'pt-[12px]',
    grid: 'h-[118px] gap-[6px] rounded-md p-xs',
    slot: 'rounded-sm'
  },
  heroMobile: {
    box: FOLDER_BOX_HERO_MOBILE,
    offset: 'pt-[6px]',
    grid: 'h-[79px] gap-[4px] rounded-md p-2xs',
    slot: 'rounded-xs'
  },
  row: {
    box: FOLDER_BOX_ROW,
    offset: 'pt-[4px]',
    grid: 'h-[45px] gap-[2px] rounded-md p-[4px]',
    slot: 'rounded-xs'
  }
};
interface FolderThumbnailProps {
  imageUrls?: string[];
  /** 사용자가 고른 폴더 색. 없으면 기본 회색 폴더다 — 목록에서 폴더를 색으로 구분하는 자리다. */
  color?: FolderColor;
  size?: FolderThumbnailSize;
  className?: string;
}
export const FolderThumbnail = ({
  imageUrls = EMPTY_IMAGE_URLS,
  color,
  size = 'card',
  className
}: FolderThumbnailProps) => {
  const style = SIZE_STYLE[size];
  const slots = Array.from({
    length: THUMBNAIL_SLOT_COUNT
  }, (_, index) => imageUrls[index]);
  return <div className={cn('relative shrink-0', style.box, className)} data-sentry-component="FolderThumbnail" data-sentry-source-file="FolderThumbnail.tsx">
      <FolderShape variant={'filled'} size={size} fill={folderColorHex(color)} data-sentry-element="FolderShape" data-sentry-source-file="FolderThumbnail.tsx" />
      <div className={cn('absolute left-0 top-1/2 w-full -translate-y-1/2', style.offset)}>
        <div className={cn('grid grid-cols-2 grid-rows-2 overflow-hidden', style.grid)}>
          {slots.map((url, index) => url ? <img key={index} alt="" className={cn('size-full border border-white object-cover', style.slot)} src={url} /> : <div key={index} className={cn('size-full border border-assistive bg-gray-200', style.slot)} />)}
        </div>
      </div>
    </div>;
};